import * as yup from "yup";
import { t } from "i18next";
import { testPhoneNumber } from "@/shared/yup";
import { installationConfig } from "@/shared/constants/installation-config";

export const getPhoneNumberSchema = () => {
  return yup.object({
    mobilePhone: yup
      .string()
      .required(t("validation.required"))
      .test("phone-format", function (value) {
        return testPhoneNumber(this, value, installationConfig.phoneRegex);
      }),
  });
};
